import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const DocumentUploadApi = createApi({
    reducerPath: "storage/files",
    baseQuery: axiosBaseQuery,
    tagTypes: ["documentList"],
    endpoints: (builder) =>({
        documentFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['documentList'],
            query: (query = '') => ({
                url: "storage/files/" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        documentCreate: builder.mutation({
            invalidatesTags: ['documentList'],
            query: (data) => ({
                url: "storage/files",
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        documentDelete: builder.mutation({
            invalidatesTags: ['documentList'],
            query: (id)=>({url: "/storage/files/"+id, method: "DELETE"})
        }),
    })
})

export const { useDocumentFindAllQuery, useDocumentCreateMutation, useDocumentDeleteMutation } = DocumentUploadApi;
export {DocumentUploadApi};
